import { connect } from 'react-redux'

import { selectFirstReplyResolvedRatioGauge } from 'ducks/reports/gauges'

import { PercentGauge } from 'ducks/reports/visualizations'

const staticSelect = {
  height: 300,
  scale: { y: 'percent' },
}
const select = (state, props) => ({
  ...staticSelect,
  gauge: selectFirstReplyResolvedRatioGauge(state, props),
})
export default connect(select)(PercentGauge)
